webpackJsonp([1],{

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_side__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_side___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_side__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_main__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__view_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_statistics__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_statistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__view_statistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_statistics_day__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_statistics_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__view_statistics_day__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    components: {
      header: __WEBPACK_IMPORTED_MODULE_3__components_header___default.a,
      side: __WEBPACK_IMPORTED_MODULE_4__components_side___default.a,
      main: __WEBPACK_IMPORTED_MODULE_5__view_main___default.a
    }
  }, {
    path: '/statistics',
    components: {
      header: __WEBPACK_IMPORTED_MODULE_3__components_header___default.a,
      side: __WEBPACK_IMPORTED_MODULE_4__components_side___default.a,
      main: __WEBPACK_IMPORTED_MODULE_6__view_statistics___default.a
    }
  }, {
    path: '/statistics/day',
    components: {
      header: __WEBPACK_IMPORTED_MODULE_3__components_header___default.a,
      side: __WEBPACK_IMPORTED_MODULE_4__components_side___default.a,
      main: __WEBPACK_IMPORTED_MODULE_7__view_statistics_day___default.a
    }
  }]
});
/*router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    next()
  }else {
    next()
  }
});*/
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(31)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(488),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(31)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(486),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//





// enumerating ECharts events for now
var ACTION_EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'focusnodeadjacency', 'unfocusnodeadjacency', 'brush', 'brushselected'];

var MOUSE_EVENTS = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousedown', 'mouseup', 'globalout'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: Object,
    theme: [String, Object],
    initOptions: Object,
    group: String,
    autoResize: Boolean,
    watchShallow: Boolean
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    // Only recalculated when accessed from JavaScript.
    // Won't update DOM on value change because getters
    // don't depend on reactive values
    width: {
      cache: false,
      get: function get() {
        return this.delegateGet('width', 'getWidth');
      }
    },
    height: {
      cache: false,
      get: function get() {
        return this.delegateGet('height', 'getHeight');
      }
    },
    isDisposed: {
      cache: false,
      get: function get() {
        return !!this.delegateGet('isDisposed', 'isDisposed');
      }
    },
    computedOptions: {
      cache: false,
      get: function get() {
        return this.delegateGet('computedOptions', 'getOption');
      }
    }
  },
  watch: {
    group: function group(_group) {
      this.chart.group = _group;
    }
  },
  methods: {
    // provide a explicit merge option method
    mergeOptions: function mergeOptions(options, notMerge, lazyUpdate) {
      this.delegateMethod('setOption', options, notMerge, lazyUpdate);
    },

    // just delegates ECharts methods to Vue component
    // use explicit params to reduce transpiled size for now
    resize: function resize(options) {
      this.delegateMethod('resize', options);
    },
    dispatchAction: function dispatchAction(payload) {
      this.delegateMethod('dispatchAction', payload);
    },
    convertToPixel: function convertToPixel(finder, value) {
      return this.delegateMethod('convertToPixel', finder, value);
    },
    convertFromPixel: function convertFromPixel(finder, value) {
      return this.delegateMethod('convertFromPixel', finder, value);
    },
    containPixel: function containPixel(finder, value) {
      return this.delegateMethod('containPixel', finder, value);
    },
    showLoading: function showLoading(type, options) {
      this.delegateMethod('showLoading', type, options);
    },
    hideLoading: function hideLoading() {
      this.delegateMethod('hideLoading');
    },
    getDataURL: function getDataURL(options) {
      return this.delegateMethod('getDataURL', options);
    },
    getConnectedDataURL: function getConnectedDataURL(options) {
      return this.delegateMethod('getConnectedDataURL', options);
    },
    clear: function clear() {
      this.delegateMethod('clear');
    },
    dispose: function dispose() {
      this.delegateMethod('dispose');
    },
    delegateMethod: function delegateMethod(name) {
      var _chart;

      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].util.warn('Cannot call [' + name + '] before the chart is initialized. Set prop [options] first.', this);
        return;
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_chart = this.chart)[name].apply(_chart, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args));
    },
    delegateGet: function delegateGet(name, method) {
      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].util.warn('Cannot get [' + name + '] before the chart is initialized. Set prop [options] first.', this);
      }
      return this.chart[method]();
    },
    init: function init() {
      var _this = this;

      if (this.chart) {
        return;
      }

      var chart = __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.init(this.$el, this.theme, this.initOptions);

      if (this.group) {
        chart.group = this.group;
      }

      chart.setOption(this.options, true);

      // expose ECharts events as custom events
      ACTION_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);
        });
      });
      MOUSE_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);

          // for backward compatibility, may remove in the future
          _this.$emit('chart' + event, params);
        });
      });

      if (this.autoResize) {
        this.__resizeHanlder = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
          chart.resize();
        }, 100, { leading: true });
        window.addEventListener('resize', this.__resizeHanlder);
      }

      this.chart = chart;
    },
    destroy: function destroy() {
      if (this.autoResize) {
        window.removeEventListener('resize', this.__resizeHanlder);
      }
      this.dispose();
      this.chart = null;
    },
    refresh: function refresh() {
      this.destroy();
      this.init();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$watch('options', function (options) {
      if (!_this2.chart && options) {
        _this2.init();
      } else {
        _this2.chart.setOption(_this2.options, true);
      }
    }, { deep: !this.watchShallow });

    var watched = ['theme', 'initOptions', 'autoResize', 'watchShallow'];
    watched.forEach(function (prop) {
      _this2.$watch(prop, function () {
        _this2.refresh();
      }, { deep: true });
    });
  },
  mounted: function mounted() {
    // auto init if `options` is already provided
    if (this.options) {
      this.init();
    }
  },
  activated: function activated() {
    if (this.autoResize) {
      this.chart && this.chart.resize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.destroy();
  },
  connect: function connect(group) {
    if (typeof group !== 'string') {
      group = group.map(function (chart) {
        return chart.chart;
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.connect(group);
  },
  disconnect: function disconnect(group) {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.disConnect(group);
  },
  registerMap: function registerMap() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerMap.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  },
  registerTheme: function registerTheme() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerTheme.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'side',
  data: function data() {
    return {};
  },
  created: function created() {},

  watch: {},
  methods: {}
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        nn: '',
        beginTime: '',
        endTime: '',
        pageNum: 1,
        short: -1
      },
      danmu: {}
    };
  },
  created: function created() {
    this.getList();
  },

  methods: {
    getList: function getList() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_api__["a" /* default */].danmu.list(this.searchForm).then(function (result) {
        _this.loading = false;
        _this.danmu = result.data.res;
      }).catch(function () {
        _this.loading = false;
      });
    },
    timeFormat: function timeFormat(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('YYYY-MM-DD HH:mm:ss');
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.getList();
    },
    goSearch: function goSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    sortChange: function sortChange(obj) {
      if (obj.prop === 'createdAt') {
        if (obj.order === 'ascending') {
          this.searchForm.short = 1;
        } else {
          this.searchForm.short = -1;
        }
      }
      this.searchForm.pageNum = 1;
      this.getList();
    }
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.getList();
  },
  data: function data() {
    return {
      searchForm: {
        day: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, "days").startOf('day').format()
      },
      allData: {
        speakLevelDistr: []
      },
      loading: false,
      chartOption: {
        speakLevelDistr: {
          title: {
            text: '发言者等级分布（前二十）',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: []
        },
        speakBrandDistr: {
          title: {
            text: '发言者牌子等级分布（前十）',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: []
        }
      }
    };
  },

  components: {},
  watch: {},
  methods: {
    chart: function chart() {
      var speakLevelDistrArr = [];
      var speakBrandDistrArr = [];
      if (this.allData.speakLevelDistr) {
        var tmpSpeakLevelDistrArr = [];
        tmpSpeakLevelDistrArr = this._.orderBy(this.allData.speakLevelDistr, ['count', '_id'], ['desc', 'asc']);
        // tmpSpeakLevelDistrArr = this._.slice(tmpSpeakLevelDistrArr, 0, 10)
        var otherSpeakLevelCount = 0;
        tmpSpeakLevelDistrArr.forEach(function (value, index, array) {
          if (index < 20) {
            speakLevelDistrArr.push({ value: value.count, name: value._id + '级' });
          } else {
            otherSpeakLevelCount += value.count;
          }
        });
        speakLevelDistrArr.push({ value: otherSpeakLevelCount, name: '其他等级' });
      }
      this.chartOption.speakLevelDistr.series = [];
      this.chartOption.speakLevelDistr.series.push({
        name: '等级',
        type: 'pie',
        radius: '70%',
        center: ['50%', '60%'],
        data: speakLevelDistrArr
      });
      if (this.allData.speakBrandDistr) {
        var tmpSpeakBrandDistrArr = [];
        tmpSpeakBrandDistrArr = this._.orderBy(this.allData.speakBrandDistr, ['count', '_id'], ['desc', 'asc']);
        // tmpSpeakBrandDistrArr = this._.slice(tmpSpeakBrandDistrArr, 0, 10)
        var otherSpeakBrandCount = 0;
        tmpSpeakBrandDistrArr.forEach(function (value, index, array) {
          if (index < 10) {
            speakBrandDistrArr.push({ value: value.count, name: value._id + '级' });
          } else {
            otherSpeakBrandCount += value.count;
          }
        });
        speakBrandDistrArr.push({ value: otherSpeakBrandCount, name: '其他等级' });
      }
      this.chartOption.speakBrandDistr.series = [];
      this.chartOption.speakBrandDistr.series.push({
        name: '牌子等级',
        type: 'pie',
        radius: '70%',
        center: ['50%', '60%'],
        data: speakBrandDistrArr
      });
    },
    getList: function getList() {
      var _this = this;

      if (this.searchForm.day) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].danmu.statisticsDayList({ day: this.searchForm.day }).then(function (result) {
          if (result.data.code === '0000') {
            _this.allData = result.data.res;
            _this.chart();
            _this.loading = false;
          } else {
            _this.loading = false;
          }
        }).catch(function (result) {
          console.log(result);
          _this.loading = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.getStatisticsList();
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        beginTime: new Date(),
        filterOnline: true
      },
      statisticsList: [],
      chartOption: {
        compositeOption: {
          title: {
            text: '发言数、进入数、关注增幅数折线图',
            left: 'center'
          },
          legend: {
            show: true,
            data: ['发言数', '进入数', '关注增幅数'],
            top: 'bottom',
            left: 'center'
          },
          tooltip: {
            show: true
          },
          xAxis: [{
            type: 'time',
            splitNumber: '10',
            minInterval: 3600 * 24 * 1000,
            maxInterval: 3600 * 24 * 7000
          }],
          yAxis: [{
            type: 'value'
          }],
          series: []
        },
        danmuOption: {
          title: {
            text: '弹幕数、人气数折线图',
            left: 'center'
          },
          legend: {
            show: true,
            data: ['弹幕数', '人气数'],
            top: 'bottom',
            left: 'center'
          },
          tooltip: {
            show: true
          },
          xAxis: [{
            type: 'time',
            splitNumber: '10',
            minInterval: 3600 * 24 * 1000,
            maxInterval: 3600 * 24 * 7000
          }],
          yAxis: [{
            type: 'value'
          }],
          series: []
        }
      }
    };
  },

  components: {},
  watch: {},
  computed: {},
  methods: {
    chart: function chart() {
      var composite = this.$refs.composite;
      var danmu = this.$refs.danmu;
      var spakArr = [];
      var enterArr = [];
      var danmuArr = [];
      var fansArr = [];
      var onlineArr = [];
      var lastFans = 0;
      if (this.statisticsList) {
        this.statisticsList.forEach(function (value, index, arr) {
          spakArr.push([value.calculatedDate, value.speakSum]);
          enterArr.push([value.calculatedDate, value.enterSum]);
          danmuArr.push([value.calculatedDate, value.danmuSum]);
          onlineArr.push([value.calculatedDate, value.onlineMax]);
          if (index === 0) {
            lastFans = value.fansMax;
          } else {
            lastFans = arr[index - 1].fansMax;
          }
          var fansNum = parseInt(value.fansMax - lastFans);
          fansArr.push([value.calculatedDate, fansNum]);
        });
        this.chartOption.compositeOption.series = [];
        this.chartOption.compositeOption.series.push({
          name: '发言数',
          type: 'line',
          data: spakArr
        }, {
          name: '进入数',
          type: 'line',
          data: enterArr
        }, {
          name: '关注增幅数',
          type: 'line',
          data: fansArr
        });
        this.chartOption.danmuOption.series = [];
        this.chartOption.danmuOption.series.push({
          name: '弹幕数',
          type: 'line',
          data: danmuArr
        }, {
          name: '人气数',
          type: 'line',
          data: onlineArr
        });
        composite.setOptions(this.chartOption.compositeOption);
        composite.setOptions(this.chartOption.danmuOption);
      }
    },
    getStatisticsList: function getStatisticsList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].danmu.statisticsList({ month: this.searchForm.beginTime, filterOnline: this.searchForm.filterOnline }).then(function (result) {
        _this.statisticsList = result.data.res;
        _this.chart();
      }).catch(function (result) {});
    },

    dateFormat: function dateFormat(row) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.calculatedDate).format('YYYY-MM-DD');
    },
    goSearch: function goSearch() {
      this.getStatisticsList();
    }
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);



// axios 配置
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 60000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "/api";

// http request 拦截器
/*axios.interceptors.request.use(function(config){

  return config;
},function(err){
  return Promise.reject(err);
});*/
// http response 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    __WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"].error(error.response.data.message);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
  } else {
    error.response = {};
    __WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"].error("网络错误，请稍后重试");
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_component_tooltip__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_title__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_default_index_css__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_normalize_css__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_base_css__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_css_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// import './assets/js/validate.js';


// import Vuex from 'vuex'
// import store from './store'






// import VueCookie from 'vue-cookie';
// import './assets/global.css'


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.axios = __WEBPACK_IMPORTED_MODULE_14_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype._ = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a;
// Vue.use(Vuex);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('chart', __WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts_vue___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 145,
	"./af.js": 145,
	"./ar": 152,
	"./ar-dz": 146,
	"./ar-dz.js": 146,
	"./ar-kw": 147,
	"./ar-kw.js": 147,
	"./ar-ly": 148,
	"./ar-ly.js": 148,
	"./ar-ma": 149,
	"./ar-ma.js": 149,
	"./ar-sa": 150,
	"./ar-sa.js": 150,
	"./ar-tn": 151,
	"./ar-tn.js": 151,
	"./ar.js": 152,
	"./az": 153,
	"./az.js": 153,
	"./be": 154,
	"./be.js": 154,
	"./bg": 155,
	"./bg.js": 155,
	"./bm": 156,
	"./bm.js": 156,
	"./bn": 157,
	"./bn.js": 157,
	"./bo": 158,
	"./bo.js": 158,
	"./br": 159,
	"./br.js": 159,
	"./bs": 160,
	"./bs.js": 160,
	"./ca": 161,
	"./ca.js": 161,
	"./cs": 162,
	"./cs.js": 162,
	"./cv": 163,
	"./cv.js": 163,
	"./cy": 164,
	"./cy.js": 164,
	"./da": 165,
	"./da.js": 165,
	"./de": 168,
	"./de-at": 166,
	"./de-at.js": 166,
	"./de-ch": 167,
	"./de-ch.js": 167,
	"./de.js": 168,
	"./dv": 169,
	"./dv.js": 169,
	"./el": 170,
	"./el.js": 170,
	"./en-au": 171,
	"./en-au.js": 171,
	"./en-ca": 172,
	"./en-ca.js": 172,
	"./en-gb": 173,
	"./en-gb.js": 173,
	"./en-ie": 174,
	"./en-ie.js": 174,
	"./en-nz": 175,
	"./en-nz.js": 175,
	"./eo": 176,
	"./eo.js": 176,
	"./es": 179,
	"./es-do": 177,
	"./es-do.js": 177,
	"./es-us": 178,
	"./es-us.js": 178,
	"./es.js": 179,
	"./et": 180,
	"./et.js": 180,
	"./eu": 181,
	"./eu.js": 181,
	"./fa": 182,
	"./fa.js": 182,
	"./fi": 183,
	"./fi.js": 183,
	"./fo": 184,
	"./fo.js": 184,
	"./fr": 187,
	"./fr-ca": 185,
	"./fr-ca.js": 185,
	"./fr-ch": 186,
	"./fr-ch.js": 186,
	"./fr.js": 187,
	"./fy": 188,
	"./fy.js": 188,
	"./gd": 189,
	"./gd.js": 189,
	"./gl": 190,
	"./gl.js": 190,
	"./gom-latn": 191,
	"./gom-latn.js": 191,
	"./gu": 192,
	"./gu.js": 192,
	"./he": 193,
	"./he.js": 193,
	"./hi": 194,
	"./hi.js": 194,
	"./hr": 195,
	"./hr.js": 195,
	"./hu": 196,
	"./hu.js": 196,
	"./hy-am": 197,
	"./hy-am.js": 197,
	"./id": 198,
	"./id.js": 198,
	"./is": 199,
	"./is.js": 199,
	"./it": 200,
	"./it.js": 200,
	"./ja": 201,
	"./ja.js": 201,
	"./jv": 202,
	"./jv.js": 202,
	"./ka": 203,
	"./ka.js": 203,
	"./kk": 204,
	"./kk.js": 204,
	"./km": 205,
	"./km.js": 205,
	"./kn": 206,
	"./kn.js": 206,
	"./ko": 207,
	"./ko.js": 207,
	"./ky": 208,
	"./ky.js": 208,
	"./lb": 209,
	"./lb.js": 209,
	"./lo": 210,
	"./lo.js": 210,
	"./lt": 211,
	"./lt.js": 211,
	"./lv": 212,
	"./lv.js": 212,
	"./me": 213,
	"./me.js": 213,
	"./mi": 214,
	"./mi.js": 214,
	"./mk": 215,
	"./mk.js": 215,
	"./ml": 216,
	"./ml.js": 216,
	"./mr": 217,
	"./mr.js": 217,
	"./ms": 219,
	"./ms-my": 218,
	"./ms-my.js": 218,
	"./ms.js": 219,
	"./mt": 220,
	"./mt.js": 220,
	"./my": 221,
	"./my.js": 221,
	"./nb": 222,
	"./nb.js": 222,
	"./ne": 223,
	"./ne.js": 223,
	"./nl": 225,
	"./nl-be": 224,
	"./nl-be.js": 224,
	"./nl.js": 225,
	"./nn": 226,
	"./nn.js": 226,
	"./pa-in": 227,
	"./pa-in.js": 227,
	"./pl": 228,
	"./pl.js": 228,
	"./pt": 230,
	"./pt-br": 229,
	"./pt-br.js": 229,
	"./pt.js": 230,
	"./ro": 231,
	"./ro.js": 231,
	"./ru": 232,
	"./ru.js": 232,
	"./sd": 233,
	"./sd.js": 233,
	"./se": 234,
	"./se.js": 234,
	"./si": 235,
	"./si.js": 235,
	"./sk": 236,
	"./sk.js": 236,
	"./sl": 237,
	"./sl.js": 237,
	"./sq": 238,
	"./sq.js": 238,
	"./sr": 240,
	"./sr-cyrl": 239,
	"./sr-cyrl.js": 239,
	"./sr.js": 240,
	"./ss": 241,
	"./ss.js": 241,
	"./sv": 242,
	"./sv.js": 242,
	"./sw": 243,
	"./sw.js": 243,
	"./ta": 244,
	"./ta.js": 244,
	"./te": 245,
	"./te.js": 245,
	"./tet": 246,
	"./tet.js": 246,
	"./th": 247,
	"./th.js": 247,
	"./tl-ph": 248,
	"./tl-ph.js": 248,
	"./tlh": 249,
	"./tlh.js": 249,
	"./tr": 250,
	"./tr.js": 250,
	"./tzl": 251,
	"./tzl.js": 251,
	"./tzm": 253,
	"./tzm-latn": 252,
	"./tzm-latn.js": 252,
	"./tzm.js": 253,
	"./uk": 254,
	"./uk.js": 254,
	"./ur": 255,
	"./ur.js": 255,
	"./uz": 257,
	"./uz-latn": 256,
	"./uz-latn.js": 256,
	"./uz.js": 257,
	"./vi": 258,
	"./vi.js": 258,
	"./x-pseudo": 259,
	"./x-pseudo.js": 259,
	"./yo": 260,
	"./yo.js": 260,
	"./zh-cn": 261,
	"./zh-cn.js": 261,
	"./zh-hk": 262,
	"./zh-hk.js": 262,
	"./zh-tw": 263,
	"./zh-tw.js": 263
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(31)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(490),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(344);

var api = {
  danmu: {
    //弹幕列表
    list: function list(params) {
      return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/danmu/list", { params: params });
    },
    //统计
    statisticsList: function statisticsList(params) {
      return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/statistics/info/month", { params: params });
    },
    // 日统计
    statisticsDayList: function statisticsDayList(params) {
      return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/statistics/info/day", { params: params });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(31)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(31)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(484),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(31)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(31)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "danmu-page"
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.goSearch($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.searchForm.nn),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "nn", $$v)
      },
      expression: "searchForm.nn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "begin-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "editable": false,
      "type": "datetime",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.searchForm.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "beginTime", $$v)
      },
      expression: "searchForm.beginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "editable": false,
      "type": "datetime",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.searchForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "endTime", $$v)
      },
      expression: "searchForm.endTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {}, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.danmu.list,
      "stripe": "",
      "default-sort": {
        prop: 'createdAt',
        order: 'descending'
      }
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "nn",
      "label": "用户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "txt",
      "label": "内容"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "label": "创建时间",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.timeFormat(scope.row.createdAt)) + "\n        ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination-inner",
    attrs: {
      "current-page": _vm.danmu.pageNum,
      "page-size": _vm.danmu.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "page-count": _vm.danmu.pages,
      "total": _vm.danmu.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.danmu, "pageNum", $event)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "danmu-page"
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getList($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "查询日期"
    }
  }, [_c('el-form-item', {
    staticClass: "begin-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "editable": false,
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.searchForm.day),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "day", $$v)
      },
      expression: "searchForm.day"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('chart', {
    ref: "speakLevelDistr",
    staticClass: "statistics-chart",
    attrs: {
      "options": _vm.chartOption.speakLevelDistr
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('chart', {
    ref: "speakBrandDistr",
    staticClass: "statistics-chart",
    attrs: {
      "options": _vm.chartOption.speakBrandDistr
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h2', [_vm._v("每日弹幕发言数排名(前一百)")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allData.speakList,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "排名",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nn",
      "label": "昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "牌子等级"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.brid === '156277') ? _c('span', [_vm._v(_vm._s(scope.row.bl))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "发言数"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view', {
    attrs: {
      "name": "side"
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "main",
    attrs: {
      "name": "main"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "danmu-page"
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.goSearch($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "查询月份"
    }
  }, [_c('el-form-item', {
    staticClass: "begin-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "editable": false,
      "type": "month",
      "placeholder": "选择月份"
    },
    model: {
      value: (_vm.searchForm.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "beginTime", $$v)
      },
      expression: "searchForm.beginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "过滤未开播数据"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "开",
      "off-text": "关"
    },
    model: {
      value: (_vm.searchForm.filterOnline),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "filterOnline", $$v)
      },
      expression: "searchForm.filterOnline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "数据说明",
      "type": "info",
      "description": "数据每日统计一次。受斗鱼API和采集周期所限：进入房间人数为10级以上数据；最高人气数、最高关注数为每日采集数据的最高值，采集间隔为5分钟可能并非当日极值。2017年9月试运行期间数据采集存在不稳定情况，其中1、2、3、14日的关注数为手动修复数据，且缺失大量开播情况数据。"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('chart', {
    ref: "danmu",
    staticClass: "statistics-chart",
    attrs: {
      "options": _vm.chartOption.danmuOption
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('chart', {
    ref: "composite",
    staticClass: "statistics-chart",
    attrs: {
      "options": _vm.chartOption.compositeOption
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.statisticsList,
      "stripe": "",
      "default-sort": {
        prop: 'calculatedDate',
        order: 'ascending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "calculatedDate",
      "label": "统计日期",
      "sortable": "",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danmuSum",
      "label": "弹幕总数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "speakSum",
      "label": "发言人数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enterSum",
      "label": "进入房间人数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "onlineMax",
      "label": "最高人气数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fansMax",
      "label": "最高关注数",
      "sortable": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  })
},staticRenderFns: []}

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side"
  }, [_c('el-menu', {
    attrs: {
      "default-active": "/",
      "router": "",
      "theme": "dark"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/"
    }
  }, [_vm._v("弹幕查询")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/statistics"
    }
  }, [_vm._v("月度弹幕统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/statistics/day"
    }
  }, [_vm._v("每日弹幕统计")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo-subtitle"
  }, [_vm._v("查询系统")])])])
}]}

/***/ })

},[345]);


// WEBPACK FOOTER //
// static/js/app.19e5e4b025ac2b6a7a81.js